module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "ultrassom.ee7ad9eb.png";